import type React from "react";
import { ReactionFooter } from "@/components/common/ReactionFooter";
import type {
  Reaction,
  ReactionBreakdown,
  ReactionType,
} from "@/lib/humhub-api/types";

interface PostCardFooterProps {
  isPending?: boolean;
  isReacting?: boolean;
  localReaction: ReactionType | null;
  onReactionSelect: (reaction: ReactionType) => void | Promise<void>;
  reactionsTotal?: number;
  reactionsPreview?: Reaction[];
  reactionsBreakdown?: ReactionBreakdown;
  postContentId?: number;
  showCommentButton?: boolean;
  onCommentClick?: () => void;
  isCommentActive?: boolean;
  className?: string;
  disabled?: boolean;
}

export const PostCardFooter: React.FC<PostCardFooterProps> = ({
  isPending = false,
  isReacting = false,
  localReaction,
  onReactionSelect,
  reactionsTotal = 0,
  reactionsPreview = [],
  reactionsBreakdown,
  postContentId,
  showCommentButton = true,
  onCommentClick,
  isCommentActive = false,
  className,
  disabled = false,
}) => {
  return (
    <ReactionFooter
      localReaction={localReaction}
      onReactionSelect={onReactionSelect}
      isReacting={isReacting}
      isPending={isPending}
      disabled={disabled}
      reactionTotal={reactionsTotal}
      lastReactions={reactionsPreview}
      reactionBreakdown={reactionsBreakdown}
      reactionContentId={postContentId}
      showCommentButton={showCommentButton}
      onCommentClick={onCommentClick}
      isCommentActive={isCommentActive}
      className={className}
    />
  );
};
